import React from 'react';

import LogoCigam from './logo-cigam.svg';
import Portais from './portais.svg';
import Usuario from './usuario.svg';
import avatar from './avatar6.png';
import Sino from './sino.svg';

export const ImagemLogoCigam = () => <img src={LogoCigam} alt="Logo CIGAM" />;
export const ImagemSino = () => <img src={Sino} alt="Notificações" />;
export const ImagemPortais = () => <img src={Portais} alt="Portais" />;
export const ImagemUsuario = () => <img src={Usuario} alt="Usuário" />;
export const AvatarUsuario = () => <img src={avatar} alt="Avatar" className="avatar" />;

